import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { StudioProviders } from './components/StudioProviders';
import './styles.css';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element #root not found in index.html');

const apiBaseUrl = import.meta.env.VITE_API_URL ?? 'http://localhost:8080';
const clerkPublishableKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;
if (!clerkPublishableKey) {
  throw new Error('VITE_CLERK_PUBLISHABLE_KEY is required (see .env.example)');
}

createRoot(rootEl).render(
  <StrictMode>
    <StudioProviders apiBaseUrl={apiBaseUrl} clerkPublishableKey={clerkPublishableKey}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </StudioProviders>
  </StrictMode>,
);
